/** Button value prefix for the "Yes" (go to checkout) confirmation button. */
export const CART_CHECKOUT_STARTED_PREFIX = '__checkout_started__|';
/** Button value prefix for the "No" (stay in chat, offer product help) confirmation button. */
export const CART_CHECKOUT_NO_PREFIX = '__cart_checkout_no__|';
/** Button value for the "Keep shopping" confirmation button. */
export const CART_KEEP_SHOPPING_ACTION = '__cart_keep_shopping__';
